import React from "react";
import { motion } from "framer-motion";
import { hideAnimation, coursesAnimation } from "../animate";
import { useScroll } from "./useScroll";
import useWindowDimensions from "./useDimension";

const CourseDetail71 = (props) => {
  const { width } = useWindowDimensions();
  const [element, controls] = useScroll(width < 1000 ? 0 : 0.25);

  return (
    <div className="details">
      <div className="images">
        <img src={props.img} alt="" />
      </div>
      <motion.div
        className="desc"
        variants={coursesAnimation}
        initial="hidden"
        animate={controls}
        ref={element}
      >
        <h2>
          <span>Java詳細課程內容:</span>
        </h2>
        <p>
          從頭開始學習Java語法，內容包含基本語法、物件導向的程式架構、解決問題的邏輯思路、遇到問題狀況的處理、Debug技巧，建立扎實的Java必備知識。此外，也帶你從無到有開發完整的Java桌機遊戲，練習物件導向的程式設計，寫出商業與便捷功能，可連結資料庫、高可讀性、高維護性以及高功能性的程式碼。此課程會不斷更新以提供新的內容，根據學生的狀況與開發趨勢，不斷更新讓知識保持新鮮且豐富。
        </p>
        <p>
          Java
          是一種廣泛使用的電腦程式設計語言，擁有跨平台、物件導向等特性，廣泛應用於企業級Web應用開發和各種行動應用開發。例如:
          Android Apps,數據中心和超級計算機,桌面應用程序,數據庫連接, 資料視覺化,
          以及數據分析，都可以見到Java的應用。許多政府機關、醫療、 教育、
          國防，以及的電子交易的系統也是用Java做成的！ Java
          是非常受歡迎的程式語言，可以運用在各種領域，支援性非常強大！
        </p>
      </motion.div>
    </div>
  );
};

export default CourseDetail71;
